import { styled } from "@mui/material/styles";
import React from "react";
import { REPORT_URL } from "../../utils/environmentVariables";

const StyledIframe = styled("iframe")(() => ({
  width: "100%",
  height: "80vh",
  borderColor: "#FAFAFA",
}));

interface DiagnosticReportTabProps {
  id: string;
}

const DiagnosticReportTab: React.FC<DiagnosticReportTabProps> = ({ id }: DiagnosticReportTabProps) => {
  return (
    <div>
      <StyledIframe src={`${REPORT_URL}/${id}/solution_report/index.html`} />
    </div>
  );
};

export default DiagnosticReportTab;
